module.exports = __webpack_public_path__ + "static/media/img-2.74bae6b4.jpeg";